import styled from 'styled-components'

import { SkeletonBlock } from 'shared-components/shimmer/style'

export const Shimmer = styled(SkeletonBlock)`
  flex: 0 1 49%;
  height: 80vh;
`
